<div class="card">
  <div class="card-body">
    <spinner *ngIf="isLoading"></spinner>

    <div class="row tile-content align-items-stretch">
      <div class="col-12 d-flex flex-column justify-content-between">
        <div>
          <div class="tile-loyalty-icon mb-2">
            <svg>
              <use href="/assets/images/svg_ico/icons.svg#ic_gift_light"></use>
            </svg>
          </div>
          <div class="h1 tile-loyalty-title mb-0" i18n="@@loyalty-enrollment-tile.loyaltyEnrollmentTileTitle">
            Connect to Amadeus+Me
          </div>
          <p class="text-gray mb-0" [innerHTML]="loyaltyEnrollmentTileDescriptionString"></p>
          <a routerLink="/amadeus-plus-me/enrollment">{{ moreDetailsString }}</a>
        </div>
        <div class="mt-4 mt-lg-0">
          <div class="form-check form-check-align-top mb-2">
            <input
              class="form-check-input"
              id="agreement-terms-and-conditions-checkbox"
              type="checkbox"
              [formControl]="acceptTerms"
            />
            <label for="agreement-terms-and-conditions-checkbox" class="form-check-label">
              {{loyaltyEnrollmentTileAcceptTermsOfUseString }}
              <a href="{{ termsLink }}">
                  <span i18n="@@loyalty-enrollment-tile.loyaltyAgentsTermsAndConditions">terms and conditions</span>
              </a>
            </label>
          </div>

          <div class="tile-loyalty-auth-buttons">
            <button
              id="loyalty-tile-login-button"
              type="button"
              class="btn btn-outline-primary me-2"
              (click)="handleLoginClick()"
              i18n="@@loyalty-enrollment-tile.loyaltyEnrollmentTileLoginButton"
            >
              Login
            </button>
            <button
              id="loyalty-tile-create-account-button"
              type="button"
              class="btn btn-primary"
              (click)="handleCreateAccountClick(confirmCreateAccountHomeModal)"
              [disabled]="acceptTerms.invalid"
              i18n="@@loyalty-enrollment-tile.loyaltyEnrollmentTileCreateAccountButton"
            >
              Create account
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmCreateAccountHomeModal let-continue="close" let-back="dismiss">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@loyalty-enrollment-tile.createAccountHeading">Already have an account?</h2>
  </div>
  <div class="modal-body">
    <label i18n="@@loyalty-enrollment-tile.createAccountContent"
      >Creating a new account with a previously used email will cancel the old account without transferring the
      accumulated points. Do you want to continue?</label
    >
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-primary" (click)="back()" i18n="@@loyalty-enrollment-tile.buttonBack">
      Go Back
    </button>
    <button
      id="loyalty-tile-ok-button"
      type="button"
      class="btn btn-primary"
      (click)="continue()"
      i18n="@@loyalty-enrollment-tile.commonContinue"
    >
      Continue
    </button>
  </div>
</ng-template>
